module.exports = __webpack_public_path__ + "03080997764198e4a0ecf56cfbd93198.png";